import { useEffect, useState, useMemo } from 'react';
const TIMEOUT_EQUATION = 48 * 60 * 60 * 1000;
const useCountDown = (accountCreatedDate) => {
    const [now, setNow] = useState();
    const end = new Date(accountCreatedDate).getTime() + TIMEOUT_EQUATION;
    const time = useMemo(() => {
        if (now) {
            const diff = Math.max((end - now) / 1000, 0);
            const hours = Math.floor(diff / 3600);
            const minutes = Math.floor((diff - hours * 3600) / 60);
            const diffInSeconds = Math.max(Math.floor((end - now) / 1000), 0);
            return { diff, diffInSeconds, hours, minutes };
        }
    }, [end, now]);
    useEffect(() => {
        const loop = setInterval(() => setNow(new Date().getTime()), 1000);
        return () => clearInterval(loop);
    }, []);
    return time;
};
export default useCountDown;
//# sourceMappingURL=useCountDown.js.map